// FACTORYZA - Mock Data for Landing Page

export const companyInfo = {
  name: "FACTORYZA",
  slogan: "Tu Liquidez, Nuestra Prioridad",
  logoBlack: "https://customer-assets.emergentagent.com/job_factoryza-finance/artifacts/4mj4n0ia_noBgBlack%20%284%29.png",
  logoBlue: "https://customer-assets.emergentagent.com/job_factoryza-finance/artifacts/2aphksn1_with_padding%20%281%29.png",
  colors: {
    primary: "#0092ca",
    secondary: "#eeeeee",
    dark: "#1a1a2e",
    light: "#f8fafc"
  }
};

export const contactInfo = {
  phone: "+507 6586-5503",
  whatsapp: "50765865503",
  email: "info@factoryza.com",
  address: "Calle Isaac Hanono Missri, Torre Metrobank, Piso 10, Panamá, Rep. de Panamá",
  linkedin: "https://www.linkedin.com/company/factoryza/?viewAsMember=true"
};

export const heroContent = {
  title: "Convierte tus Facturas en Capital Inmediato",
  subtitle: "Soluciones de factoring ágiles y confiables para impulsar el crecimiento de tu empresa en Panamá",
  cta: "Solicitar Asesoría Gratis"
};

export const benefits = [
  {
    id: 1,
    title: "Liquidez Inmediata",
    description: "Recibe hasta el 90% del valor de tus facturas en solo 24 horas tras la aprobación. Olvídate de esperar los plazos de pago de tus clientes.",
    icon: "Banknote"
  },
  {
    id: 2,
    title: "Sin Endeudamiento",
    description: "El factoring no es un préstamo. No afecta tu capacidad crediticia ni genera deudas adicionales para tu empresa.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Proceso Simple",
    description: "Documentación mínima y proceso 100% digital. Te acompañamos en cada paso para que obtengas tu liquidez rápidamente.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Flexibilidad Total",
    description: "Tú decides qué facturas ceder y cuándo. Sin montos mínimos ni compromisos a largo plazo.",
    icon: "Settings2"
  },
  {
    id: 5,
    title: "Tasas Competitivas",
    description: "Analizamos tus márgenes operativos para ofrecerte tasas que impulsen tu negocio, no que lo frenen. Nuestras condiciones se adaptan a tu realidad financiera.",
    icon: "TrendingUp"
  },
  {
    id: 6,
    title: "Más que Liquidez",
    description: "Nuestro equipo cuenta con amplia experiencia en diversas industrias. No solo financiamos tus facturas, te asesoramos para hacer crecer tu negocio junto a ti.",
    icon: "Users"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Contacto Inicial",
    description: "Comunícate con nosotros vía WhatsApp o correo. Analizamos tu caso sin compromiso."
  },
  {
    id: 2,
    title: "Evaluación",
    description: "Revisamos tus facturas y el perfil crediticio de tus clientes en 24 horas."
  },
  {
    id: 3,
    title: "Aprobación",
    description: "Te presentamos una propuesta clara con tasas y condiciones transparentes."
  },
  {
    id: 4,
    title: "Desembolso",
    description: "Recibe hasta el 90% del valor de tus facturas el mismo día que se firme la cesión de créditos con el deudor."
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Qué es el factoring?",
    answer: "El factoring es un servicio financiero que te permite convertir tus cuentas por cobrar (facturas) en dinero inmediato. Cedes tus facturas a FACTORYZA y nosotros te adelantamos un porcentaje del valor, cobrando directamente a tu cliente cuando vence la factura."
  },
  {
    id: 2,
    question: "¿Qué tipo de empresas pueden usar factoring?",
    answer: "Cualquier empresa que venda a crédito a otras empresas (B2B) puede beneficiarse del factoring. Es ideal para PYMES, proveedores de grandes corporaciones, empresas de servicios, distribuidores y comercializadoras."
  },
  {
    id: 3,
    question: "¿Cuánto tiempo toma el proceso?",
    answer: "El proceso inicial de evaluación toma entre 24-48 horas. Una vez aprobado, los desembolsos posteriores pueden realizarse el mismo día de la cesión de facturas."
  },
  {
    id: 4,
    question: "¿Qué porcentaje de la factura puedo recibir?",
    answer: "Adelantamos hasta el 90% del valor de la factura. El porcentaje restante se entrega una vez que tu cliente paga, menos la comisión acordada."
  },
  {
    id: 5,
    question: "¿El factoring afecta mi historial crediticio?",
    answer: "No. El factoring no es un préstamo, por lo que no genera deuda ni afecta tu capacidad de endeudamiento. Es una venta de tus cuentas por cobrar."
  },
  {
    id: 6,
    question: "¿Qué documentos necesito para aplicar?",
    answer: "Requerimos: documentos legales de la empresa, estados financieros recientes, copia de las facturas a ceder, y documentación que respalde la relación comercial con tu cliente. Nuestro equipo te asiste en todo el proceso para completar los documentos lo antes posible y que no demores en recibir tu capital de trabajo."
  }
];

export const stats = [
  { value: "+50M", label: "Financiados en 2024" },
  { value: "48h", label: "Tiempo de Desembolso" },
  { value: "98%", label: "Clientes Satisfechos" },
  { value: "+200", label: "Empresas Atendidas" }
];

// Blog articles - "They Ask, You Answer" strategy
export const blogPosts = [
  {
    id: 1,
    slug: "que-es-factoring-como-funciona",
    title: "¿Qué es el Factoring y Cómo Funciona en Panamá?",
    excerpt: "Descubre cómo el factoring puede transformar tus cuentas por cobrar en capital de trabajo inmediato para tu empresa.",
    category: "Educación Financiera",
    readTime: "5 min",
    date: "2025-01-15",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
    featured: true
  },
  {
    id: 2,
    slug: "factoring-vs-prestamo-bancario",
    title: "Factoring vs. Préstamo Bancario: ¿Cuál es Mejor para tu PYME?",
    excerpt: "Comparamos ambas opciones de financiamiento para que tomes la mejor decisión según las necesidades de tu negocio.",
    category: "Comparativas",
    readTime: "7 min",
    date: "2025-01-08",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    featured: true
  },
  {
    id: 3,
    slug: "cuanto-cuesta-factoring-tasas",
    title: "¿Cuánto Cuesta el Factoring? Guía de Tasas y Comisiones",
    excerpt: "Te explicamos de forma transparente cómo se calculan las tasas de factoring y qué factores influyen en el costo.",
    category: "Costos",
    readTime: "6 min",
    date: "2025-01-01",
    image: "https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=800&q=80",
    featured: false
  },
  {
    id: 4,
    slug: "mejores-industrias-para-factoring",
    title: "Las 5 Industrias que Más se Benefician del Factoring en Panamá",
    excerpt: "Conoce qué sectores obtienen el mayor provecho del factoring y por qué podría ser ideal para tu industria.",
    category: "Industrias",
    readTime: "4 min",
    date: "2024-12-20",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
    featured: false
  },
  {
    id: 5,
    slug: "como-mejorar-flujo-caja-empresa",
    title: "7 Estrategias para Mejorar el Flujo de Caja de tu Empresa",
    excerpt: "Consejos prácticos para optimizar tu capital de trabajo y mantener una salud financiera sólida.",
    category: "Consejos",
    readTime: "8 min",
    date: "2024-12-15",
    image: "https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=800&q=80",
    featured: false
  },
  {
    id: 6,
    slug: "errores-comunes-factoring",
    title: "5 Errores Comunes al Usar Factoring (y Cómo Evitarlos)",
    excerpt: "Aprende de los errores más frecuentes que cometen las empresas al iniciar con factoring.",
    category: "Educación Financiera",
    readTime: "5 min",
    date: "2024-12-10",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    featured: false
  }
];
